<main class="kz-annuaire">
  <header>
    <app-breadcrumb></app-breadcrumb>
    <app-pro-listing-header
      [bannerType]="!!boxFiltered ? 'pro-box' : 'pro'"
      [listingType]="!!displayServices ? 'pro-services' : 'pros'"
      [jobType]="jobPath"></app-pro-listing-header>
    <app-pro-listing-search
      [bannerType]="!!boxFiltered ? 'pro-box' : 'pro'"></app-pro-listing-search>
  </header>

  <section class="kz-annuaire--results">
    <ng-container *ngIf="displayServices; then servicesList; else prosList"></ng-container>
    <ng-template #prosList>
      <ng-container *ngIf="proListingLoading">
        <app-pro-listing-item-waiting *appTimes="itemsPerPage">Waiting</app-pro-listing-item-waiting>
      </ng-container>

      <ng-container *ngIf="!proListingLoading">
        <ng-container *ngFor="let pro of proListing; let i = index; trackBy: trackById">
          <app-pro-listing-ad-faq *ngIf="i===2 && page === 1 && jobPath === 'interior-decorator' && !style"></app-pro-listing-ad-faq>
          <app-pro-listing-item
            [pro]="pro"
            [showDistance]="!!this.geo"
            [fetchPriority]="i < 1"
            [displayBestPrice]="true"
            (refresh)="refreshList()"
          ></app-pro-listing-item>
<!--          <app-pro-listing-banner-tender [job]="jobPath" *ngIf="i===0 && !style" ></app-pro-listing-banner-tender>-->
<!--          <app-pro-listing-banner-tender [job]="jobPath" *ngIf="i===8 && !style" [lightMode]="true" ></app-pro-listing-banner-tender>-->
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #servicesList>
      <ng-container *ngIf="proListingLoading">
        <app-pro-listing-item-waiting [reversed]="true" *appTimes="itemsPerPage">Waiting</app-pro-listing-item-waiting>
      </ng-container>
      <ng-container *ngIf="!proListingLoading">
        <app-pro-service-item *ngFor="let service of proServiceListing; let i = index; trackBy: trackById"
                              [service]="service" [listingMode]="true"
                              [fetchPriority]="i < 1"
        ></app-pro-service-item>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="!proListingLoading && ((!displayServices && proListing?.length == 0) || (displayServices && proServiceListing?.length == 0))">

      <ng-container *ngIf="!displayServices">
        <ng-container *ngIf="!style && !favorites" >
<!--          <app-pro-listing-banner-tender [job]="jobPath" *ngIf="!style" ></app-pro-listing-banner-tender>-->
        </ng-container>
      </ng-container>

      <div class="kz-annuaire--results-empty">
        <ng-container *ngIf="!displayServices">
          <ng-container *ngIf="!style && !geo && !favorites" i18n="@@pro.listing.empty">No interior decorator</ng-container>
          <ng-container *ngIf="style && !geo && !favorites">
            <div i18n="@@pro.listing.empty.styleWithoutGeo">No interior decorator matches your search: "{{ style.name }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
          <ng-container *ngIf="geo && !style && !favorites">
            <div i18n="@@pro.listing.empty.geoWithoutStyle">No interior decorator matches your search: near "{{ geoLabel }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null, geo: null, coachAtHome: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
          <ng-container *ngIf="style && geo && !favorites">
            <div i18n="@@pro.listing.empty.geoAndStyle">No interior decorator matches your search: "{{ style.name }}" near "{{ geoLabel }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null, geo: null, coachAtHome: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
          <div *ngIf="favorites" class="kz-annuaire--results-empty-favorite">
            <div class="empty-bad"><kz-icons name="bad"></kz-icons></div>
            <div i18n="@@pro.listing.empty.favorites1" class="kz-light-title">unfortunately, you have no favorites</div>
            <div><p i18n="@@pro.listing.empty.favorites2">you can add favorite decorators by clicking on their button </p></div>
            <button kzButton buttonStyle="default"  [buttonContext]="(boxFiltered) ? 'box': 'decorator'">
              <span>
                <kz-icons name="like"></kz-icons>
                <span i18n="@@pro.listing.empty.cta">Add to favorites</span>
              </span>
            </button>
            <a class="kz-annuaire--results-empty-link" [class.kz-annuaire--results-empty-link-box]="boxFiltered" [routerLink]="[].concat(['/pro'], boxPath) | kzLocalize" i18n="@@pro.listing.empty.link">Back to the list</a>
          </div>
        </ng-container>
        <ng-container *ngIf="displayServices">
          <ng-container *ngIf="!serviceType" i18n="@@pro.listing.services.empty">No deco offer</ng-container>
          <ng-container *ngIf="serviceType && !geo">
            <div i18n="@@pro.listing.services.empty.styleWithoutGeo">No deco offer matches your search: "{{ serviceType.name }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
          <ng-container *ngIf="geo && !serviceType">
            <div i18n="@@pro.listing.services.empty.geoWithoutStyle">No deco offer matches your search: near "{{ geoLabel }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null, geo: null, coachAtHome: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
          <ng-container *ngIf="serviceType && geo">
            <div i18n="@@pro.listing.services.empty.geoAndStyle">No deco offer matches your search: "{{ serviceType.name }}" near "{{ geoLabel }}", Get remote advice from an interior designer</div>
            <br><a [routerLink]="getOtherSearch()" [queryParams]="{page: null, geo: null, coachAtHome: null}" queryParamsHandling="merge" kzButton buttonStyle="flat" ><span i18n="@@pro.listing.empty.button">see list</span></a>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>
  </section>
  <kz-pagination
    *ngIf="!proListingLoading  && ((!displayServices && proListing?.length > 0) || (displayServices && proServiceListing?.length > 0))"
    [page]="page"
    [totalPages]="maxPage"
    [itemsPerPage]="itemsPerPage"
    [withRouterLinks]="true"
    [previousLink]="prevPage"
    [nextLink]="nextPage"
    [availableItemsPerPage]="itemsPerPageValues"
    (itemsPerPageChange)="changeItemPerPage($event)"
  >
  </kz-pagination>

  <ng-container *ngIf="page === 1 && !style && !geo">
    <section class="kz-annuaire--faq" *ngIf="jobPath === 'interior-decorator'">
      <app-pro-coaching-faq id="faq"></app-pro-coaching-faq>
    </section>
    <section class="kz-annuaire--faq" *ngIf="jobPath === 'interior-architect'">
      <app-pro-coaching-faq jobType="architect" id="faq2"></app-pro-coaching-faq>
    </section>
  </ng-container>
</main>
